import { Link } from 'react-router'

import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { type PolicyChangeAsk, PolicyChangeAskKind, type PolicyChangeRequest } from '@/models/policyChange'
import { AskQuestion } from './AskQuestion'
import { AskReplyForm } from './AskReplyForm'

/** What the broker is waiting on, at the top of the request: answered here, or by updating the request. */
export function PolicyChangeAskCard({
  orgId,
  request,
  ask,
}: {
  orgId: string | undefined
  request: PolicyChangeRequest
  ask: PolicyChangeAsk
}) {
  const changeRequest = ask.kind === PolicyChangeAskKind.CHANGE_REQUEST
  return (
    <Card className="border-(--amber)/40">
      <CardHeader>
        <CardTitle>Your insurance broker needs something from you</CardTitle>
        <CardDescription>
          {!changeRequest
            ? 'Your request stays where it is while you answer.'
            : request.signed
              ? 'Update your request, then send it back. You don’t need to sign it again.'
              : 'Update your request, then send it back.'}
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        <AskQuestion ask={ask} />
        {changeRequest ? (
          <div>
            <Button asChild>
              <Link to={`/insure/policy-changes/${request.id}/update`}>Update your request</Link>
            </Button>
          </div>
        ) : (
          <AskReplyForm orgId={orgId} request={request} ask={ask} />
        )}
      </CardContent>
    </Card>
  )
}
